import mixpanel from 'mixpanel-browser';
import {
  mixpanelToken,
  environment,
} from 'env';

const shouldEnableMixpanel = environment === 'prod' || environment === 'qa';
if (shouldEnableMixpanel) {
  mixpanel.init(mixpanelToken ?? '', { debug: false, ignore_dnt: true });
}
